import { Input } from "reactstrap";
import { FormInputProps } from "../../../../../types/Ecommerce";

// This component is used to create a form input field with custom styles.
const FormInput: React.FC<FormInputProps> = ({ type, placeholder, formClass, rows }) => {

  return (
    <div className={`mb-3 ${formClass ? formClass : ""}`}>
      <Input type={type} placeholder={placeholder} rows={rows} />
    </div>
  );
};

export default FormInput;